import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = ["aria-labelledby"]
const _hoisted_3 = { class: "container p-0 m-0" }
const _hoisted_4 = { class: "row p-0" }
const _hoisted_5 = { class: "col-lg-3 service-parent-layout" }
const _hoisted_6 = {
  class: "nav flex-column mb-0",
  role: "tablist"
}
const _hoisted_7 = ["onMouseover"]
const _hoisted_8 = {
  key: 1,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_9 = { class: "col-lg-9" }
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = { class: "mega-menu-submenu" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "list-unstyled mb-0" }
const _hoisted_14 = {
  key: 1,
  class: "tab-pane fade show active",
  role: "tabpanel"
}
const _hoisted_15 = { class: "mega-menu-submenu" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "list-unstyled mb-0" }

import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopMegaMenuItem',
  props: {
  title: String,
  menuId: String,
  type: String,
  services: [Object, Array],
  viewAllLink: String,
  activeMenuId: String,
},
  emits: ['showMenu', 'hideMenu'],
  setup(__props) {

const props = __props;



const activeTab = ref('');

watch(() => props.services, (newVal) => {
  if (props.type === 'grouped' && newVal && Object.keys(newVal).length > 0) {
    activeTab.value = Object.keys(newVal)[0];
  }
}, { immediate: true });

const selectTab = (tabName: string) => {
  activeTab.value = tabName;
};

const servicesInColumns = (services: any) => {
  if (!Array.isArray(services)) return [];
  const columns: any[][] = [[], [], []];
  const colSize = Math.ceil(services.length / 3);
  if (colSize === 0) return [];

  services.forEach((service, index) => {
    const colIndex = Math.floor(index / colSize);
    if (columns[colIndex]) {
      columns[colIndex].push(service);
    }
  });
  return columns;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["nav-item dropdown mega-menu", { 'show': __props.activeMenuId === __props.menuId }]),
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMenu', __props.menuId))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hideMenu')))
  }, [
    _createElementVNode("a", {
      class: "nav-link dropdown-toggle cursor-pointer",
      role: "button",
      "aria-expanded": __props.activeMenuId === __props.menuId
    }, _toDisplayString(__props.title), 9, _hoisted_1),
    _createElementVNode("div", {
      class: "dropdown-menu mega-menu-content p-0",
      "aria-labelledby": `${__props.menuId}Dropdown`
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (__props.type === 'grouped')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.services, (items, groupName) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-item",
                      role: "presentation",
                      key: groupName
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link mega-menu-link px-3", { 'active': activeTab.value === groupName }]),
                        onMouseover: ($event: any) => (selectTab(groupName))
                      }, _toDisplayString(groupName), 43, _hoisted_7)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("li", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("a", { class: "nav-link mega-menu-link px-3 active" }, "Divisions", -1)
                  ]))]))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (__props.type === 'grouped')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.services, (items, groupName) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["tab-pane fade", { 'show active': activeTab.value === groupName }]),
                      key: groupName,
                      role: "tabpanel"
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicesInColumns(items), (col, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-md-6",
                              key: index
                            }, [
                              _createElementVNode("ul", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col, (service) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: service.path
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: service.path,
                                      class: "mega-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(service.displayText), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 2))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicesInColumns(__props.services), (col, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-md-4",
                            key: index
                          }, [
                            _createElementVNode("ul", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col, (service) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: service.path
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: service.path,
                                    class: "mega-menu-link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(service.displayText), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 34))
}
}

})